import { Extension } from '@tiptap/core';
import { EventBus } from '@/eventBus/eventBus.js';

const DisableEnter = Extension.create({
  name: 'customEnter',

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { $from } = editor.state.selection;
        
        // Check if we're inside a code block - if so, allow default behavior
        const codeBlock = $from.node($from.depth).type.name === 'codeBlock';
        if (codeBlock) {
          return false; // Allow default Enter behavior in code blocks
        }
        
        // Check if we're inside inline code - if so, allow default behavior
        const inlineCode = $from.marks().some(mark => mark.type.name === 'code');
        if (inlineCode) {
          return false; // Allow default Enter behavior in inline code
        }
        
        const parent = $from.node($from.depth - 3);
        const inner = $from.node($from.depth - 1)
        if (inner.attrs["data-attributes"] == null){
          return false;
        }
        const index = $from.index($from.depth - 1);

        if (index == 0) {
          var behaviourOnReturn = true;
          //handles steps that do not have a second <p>
          const thirdChild = parent.childCount > 2 ? parent.child(2) : null;
          if (thirdChild == null) {
            //creates second paragraph if there isn't one in the step
            behaviourOnReturn = false
          }
          var parentId = parent.attrs["data-attributes"]["data-step-id"];
          if (parentId == null) {
            parentId = parent.attrs["data-attributes"]["data-temp-step-id"];
          }
          EventBus.$emit(`open_menu_enter_${parentId}`);

          return behaviourOnReturn;
        }
        else if (index == 1) {
          editor.commands.insertContent('<br>');
          return true;
        }

        return false; // Prevent default behavior

      }
    }
  },
});

export default DisableEnter;
